<template lang="pug">
  v-card.dispatch-request-list.pa-2(
    style="height: 100%; overflow: auto;")
    h2.h2 Solicitudes de Despacho
      v-layout(wrap)
        v-flex.xs12.md6.px-2
          v-text-field(
            label="Buscar"
            v-model="search"
            outline
          )
        v-flex.xs6.md3.px-2
          v-btn(
            color="primary"
            block
            large
            @click="setModel(true)"
            ) BUSCAR
        v-flex.xs6.md3.px-2
          v-btn(
            outline
            block
            large
            @click="setModel(false)"
            ) LIMPIAR

      SimpleModelDataTable(
        :model="model",
        :headers="headers"
        ref="table"
        )
        template(slot="Acciones" slot-scope="{item}")
          //- v-tooltip(
            v-if="item.g_state_id === 23"
            top
            )
            v-btn(
              icon
              slot="activator"
              @click="putInArm(item)"
              )
              v-icon.amber--text play_circle_filled
            span Iiciar Armado
          v-tooltip(
            v-if="item.g_state_id === 40"
            top
            )
            v-btn(
              icon
              slot="activator"
              @click="launchCodeModal(item)"
              )
              v-icon.teal--text assignment_ind
            span Armar Pedido
          template(v-if="item.g_state_id === 41")
            v-tooltip(
              top
              )
              v-btn(
                icon
                slot="activator"
                @click="launchCodeModal(item)"
                )
                v-icon.success--text check_circle
              span Confirmar
            v-tooltip(
              top
              )
              v-btn(
                icon
                slot="activator"
                @click="launchCodeModal(item, true)"
                )
                v-icon.red--text settings_backup_restore
              span Volver a Armar
      SalesPersonModal(
        v-model="_showCodeModal"
        :title="modalTitle"
        :code-label="`Código ${isApproving ? 'Autorización' : 'Armador'}`"
        :disabled="!isApproving && (!package_number || !package_cube)"
        @submit="handleCode"
        )
        template(slot="content")
          v-form(ref="form")
            v-layout(wrap).pa-2
              v-flex.xs12 
                v-text-field(
                  label="Número de Bultos"
                  mask="############"
                  v-model="package_number"
                  outline
                  ref="package-number"
                  :readonly="isApproving"
                  :rules="isApproving ? [] : [v => !!v || 'Campo Obligatorio']"
                  )
              v-flex.xs12 
                v-text-field(
                  label="Cubo"
                  v-model="package_cube"
                  outline
                  :readonly="isApproving"
                  :rules="isApproving ? [] : [v => !!v || 'Campo Obligatorio']"
                  )
              v-flex.xs12(v-if="isRejecting")
                v-textarea(
                  label="Comentario"
                  v-model="rejectComment"
                  outline
                )
      v-snackbar(
        :color="snackColor"
        v-model="showSnack"
      ) {{snackText}}
</template>
<script>
import SimpleModelDataTable from '../../components/SimpleModelDataTable/SimpleModelDataTable'
import SalesPersonModal from '../../components/SimpleAuth/SalespersonModal'

import WhDispatchRequest from '../../models/Warehouse/WhDispatchRequest'
import headers from './headers'
import { mapGetters } from 'vuex'

export default {
    name: 'dispatch-request-list',
    components: { SimpleModelDataTable, SalesPersonModal },
    data: () => ({
        headers,
        package_number: '',
        package_cube: '',
        activeItem: null,
        snackColor: 'success',
        showSnack: false,
        snackText: '',
        showCodeModal: false,
        isRejecting: false,
        rejectComment: '',
        model: null,
    }),
    computed: {
        ...mapGetters('AuthModule', ['branchOfficeID', 'isCallCenter']),
        // model() {
        // },
        _showCodeModal: {
            get() {
                return this.showCodeModal
            },
            set(v) {
                if (!v) {
                    this.activeItem = null
                    this.package_number = ''
                    this.package_cube = ''
                    this.isRejecting = false
                    this.rejectComment = ''
                }
                this.showCodeModal = v
            },
        },
        isApproving() {
            return this.activeItem ? this.activeItem.g_state_id === 41 : false
        },
        modalTitle() {
            return this.isRejecting
                ? 'Solicitar Rearmado de Pedido'
                : this.isApproving
                ? 'Autorizar Solicitud de Despacho'
                : 'Armar Pedido'
        },
    },
    methods: {
        launchCodeModal(item, isRejecting = false) {
            this.activeItem = item
            this._showCodeModal = true
            this.isRejecting = isRejecting
            if (!this.isApproving)
                setTimeout(() => this.$refs['package-number'].focus(), 50)
        },
        handleCode(code) {
            if (this.isRejecting) return this.handleReject(code)
            if (!this.isApproving) return this.handleArm(code)
            else return this.handleApprove(code)
        },
        handleReject(code) {
            if (!code) return
            new WhDispatchRequest({
                id: this.activeItem.id,
            })
                .inRevisionToInArmed({
                    auth_code: code,
                    comment: this.rejectComment,
                })
                .then(() => {
                    this.launchSnack(
                        'success',
                        'Se ha regresado la solicitud de despacho al estado "En Armado"'
                    )
                    this._showCodeModal = false
                    this.$refs.table.refresh()
                })
                .catch(e =>
                    this.launchSnack(
                        'error',
                        e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.error
                            ? e.response.data.error
                            : 'Ha ocurrido un error'
                    )
                )
        },
        handleArm(code) {
            if (!this.$refs.form.validate()) return
            if (!code) return
            new WhDispatchRequest({
                id: this.activeItem.id,
            })
                .inArmedToRevision({
                    auth_code: code,
                    package_number: this.package_number,
                    package_cube: this.package_cube,
                })
                .then(() => {
                    this.launchSnack(
                        'success',
                        'Armado registrado exitosamente'
                    )
                    this._showCodeModal = false
                    this.$refs.table.refresh()
                })
                .catch(e =>
                    this.launchSnack(
                        'error',
                        e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.error
                            ? e.response.data.error
                            : 'Ha ocurrido un error'
                    )
                )
        },
        handleApprove(code) {
            if (!code) return
            new WhDispatchRequest({
                id: this.activeItem.id,
            })
                .confirm({
                    auth_code: code,
                })
                .then(() => {
                    this.launchSnack(
                        'success',
                        'Armado de la solicitud de despacho confirmado exitosamente'
                    )
                    this._showCodeModal = false
                    this.$refs.table.refresh()
                })
                .catch(e =>
                    this.launchSnack(
                        'error',
                        e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.error
                            ? e.response.data.error
                            : 'Ha ocurrido un error'
                    )
                )
        },
        launchSnack(color, text) {
            this.snackColor = color
            this.snackText = text
            this.showSnack = true
            setTimeout(() => {
                this.showSnack = false
            }, 7000)
        },
        putInArm(item) {
            new WhDispatchRequest({
                id: item.id,
            })
                .inArmed()
                .then(() => {
                    this.launchSnack(
                        'success',
                        'Solicitud puesta en estado "En Armado"'
                    )
                    this.$refs.table.refresh()
                })
                .catch(e =>
                    this.launchSnack(
                        'error',
                        e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.error
                            ? e.response.data.error
                            : 'Ha ocurrido un error'
                    )
                )
        },
        setModel(search = false) {
            let model = new WhDispatchRequest()
                .include(
                    'g_state',
                    'sl_customer',
                    'sl_customer_branch_offices.g_commune',
                    'pch_payment_condition',
                    'g_armer_user.hr_employee'
                )
                .whereIn('g_state_id', [/*23,*/ 40, 41])
                .where('g_branch_office_id', this.branchOfficeID)
            if (search) model = model.where('search', this.search)
            else this.search = ''
            this.model = model
        },
    },
    watch: {
        activeItem(v) {
            if (v && this.isApproving) {
                this.package_number = v.package_number
                this.package_cube = v.package_cube
            }
        },
    },
    created() {
        this.setModel()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            !ctx.isCallCenter ? next('/') : next()
        })
    },
}
</script>
